import { render } from "./sv-paging.vue?vue&type=template&id=7aeaf732&scoped=true&ts=true"
import script from "./sv-paging?vue&type=script&lang=ts&external"
export * from "./sv-paging?vue&type=script&lang=ts&external"

import "./sv-paging.scss?vue&type=style&index=0&id=7aeaf732&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aeaf732"]])

export default __exports__